var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\r\n  Dashboard\r\n  "),_c('md-button',{staticClass:"md-fab md-fab-bottom-right md-primary",on:{"click":_vm.newUnitPlan}},[_c('md-icon',[_vm._v("add")])],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-049197d0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dashboard.vue
// module id = null
// module chunks = 